import React from 'react';
import './LoadingPix.css'; // Supondo que o arquivo CSS esteja na mesma pasta
import { Box } from '@mui/material';

const LoadingPix = () => (
  <div className="typing-indicator">
    <div className="typing-circle"></div>
    <div className="typing-circle"></div>
    <div className="typing-circle"></div>
    <div className="typing-shadow"></div>
    <div className="typing-shadow"></div>
    <div className="typing-shadow"></div>
  </div>

);

export default LoadingPix;
